import { init } from "@nosto/preact"
import { Category } from "./components"
import { defaultConfig } from "./config"
import { defineExtendedNostoCard } from "./web-components/extended-nosto-card"

import "./styles/index.css"
import { getWizardConfig } from "./wizard"

init({
    ...window.nostoTemplatesConfig,

    /* search */
    // serpComponent: Serp,
    // historyComponent: History,
    // autocompleteComponent: Autocomplete,
    // inputCssSelector: "#search",
    // contentCssSelector: "#content",
    // formCssSelector: "#search-form",
    // serpPath: '/search',
    // serpPathRedirect: true,
    // serpQuery: {
    //     products: {
    //         fields: [
    //             "productId", "url", "categories",
    //             "name", "tags1",
    //             "imageUrl", "alternateImageUrls",
    //             "brand", "availability",
    //             "price", "listPrice", "onDiscount",
    //             "customFields.key", "customFields.value",
    //             "skus.name", "skus.price", "skus.listPrice",
    //             "skus.availability", "skus.id", "skus.imageUrl",
    //             "skus.customFields.key", "skus.customFields.value",
    //             "skus.inventoryLevel"
    //         ],
    //         facets: ["*"],
    //         size: defaultConfig.serpSize,
    //         from: 0
    //     }
    // },
    // autocompleteQuery: {
    //     products: {
    //         fields: [
    //             "productId", "url", "categories",
    //             "name", "tags1",
    //             "imageUrl", "alternateImageUrls",
    //             "brand", "availability",
    //             "price", "listPrice", "onDiscount",
    //             "customFields.key", "customFields.value",
    //             "skus.name", "skus.price", "skus.listPrice",
    //             "skus.availability", "skus.id", "skus.imageUrl",
    //             "skus.customFields.key", "skus.customFields.value",
    //             "skus.inventoryLevel"
    //         ],
    //         size: defaultConfig.autocompleteProductsSize
    //     },
    //     keywords: {
    //         fields: ["keyword", "_highlight.keyword"],
    //         size: defaultConfig.autocompleteKeywordsSize,
    //         facets: ["*"]
    //     }
    // },

    /* category */
    categoryComponent: Category,
    serpUrlMapping: {
        query: "q",
        "products.filter": "filter",
        "products.page": "page",
        "products.size": "pageSize",
        "products.sort": "sort"
    },
    compressUrlParameters: true,
    fallback: true,
    persistentSearchCache: true,
    preservePageScroll: true,
    categoryCssSelector: '#main-collection-product-grid',
    categoryQuery() {
        return {
            name: 'serp',
            products: {
                fields: [ "productId", "url", "name" ],
                // categoryPath: this.categoryPath(),
                categoryId: this.categoryId(),
                size: defaultConfig.serpSize,
                from: 0,
            }
        }
    },

    // Apply configuration wizard last
    ...getWizardConfig(),
    // Configuration here will override the changes in the wizard
})
.then(async () => {
    await defineExtendedNostoCard();
})